import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ISaveSocialClipSelectionV1Request } from './save-social-clip-selection-v1-request';
import type { ISaveSocialClipSelectionV1Response } from './save-social-clip-selection-v1-response';
import { saveSocialClipSelectionV1ResponseSchema } from './save-social-clip-selection-v1-response';

export async function saveSocialClipSelectionV1Api(
  challengeId: number,
  body: ISaveSocialClipSelectionV1Request,
): Promise<IValidatedResponse<ISaveSocialClipSelectionV1Response>> {
  return postRequest<ISaveSocialClipSelectionV1Response>({
    path: `/sys/social/v1/challenges/${challengeId}/clip-selection`,
    body,
    schema: saveSocialClipSelectionV1ResponseSchema,
  });
}
